import debounce from 'lodash/debounce';

const OrderAutofill = {
  /**
   * Create
   * @param {HTMLFormElement} node
   * @return {void}
   */
  create(node) {
    this.node = node;

    // Debounce user input to prevent overflowing the API
    const debouncedKeyup = debounce(this.search.bind(this), 200);

    // Ignore arrow keys and spaces to fix the API from being called on
    // useless key input
    const ignoreKeys = [40, 38, 39, 37, 32];

    // Listen for changes on the autocomplete field
    this.node.addEventListener('keyup', (e) => {
      if (ignoreKeys.indexOf(e.keyCode) >= 0) {
        return true;
      }

      // Check if it resembles an e-mailaddress
      if (this.node.value.indexOf('@') <= 0 || this.node.value.indexOf('.') <= 0) {
        return true;
      }

      debouncedKeyup(this.node.value);

      return true;
    });
  },

  /**
   * Fetch products from the API
   * @return {void}
   */
  search(email) {
    window.axios.get(`/admin/api/customer?email=${email}`)
      .then((res) => {
        // Output data to Awesomplete
        this.list = res.data;

        this.outputToDOM();
      })
      .catch((err) => {
        console.error(err); // eslint-disable-line no-console
      });
  },

  /**
   * Output the list from the API to the DOM
   * @return {void}
   */
  outputToDOM() {
    const $fillItems = $('[data-fill]');

    $fillItems.toArray().forEach((input) => {
      const key = input.dataset.fill;
      const keys = key.split('.');

      // Find the value for this field in the list
      const val = this.retrieveValueFromList(keys);

      if (val) {
        this.setValueOnInput(input, val);
      }
    });
  },

  /**
   * Simple helper function to set a value on an input field
   * @param {HTMLElement} input
   * @param {String|Number} value
   * @return {void}
   */
  setValueOnInput(input, value) {
    input.value = value;
  },

  /**
   * Retrieve a value from the list using a recursive loop for nested object retrieval
   * @param {Array} arr
   * @return {void}
   */
  retrieveValueFromList(arr) {
    return arr.reduce((accumulator, item) => {
      if (accumulator && typeof accumulator[item] !== 'undefined') {
        return accumulator[item];
      }

      if (typeof this.list[item] !== 'undefined') {
        return this.list[item];
      }

      return null;
    }, null);
  },
};

export default OrderAutofill;
